module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Nästa","track":"Next"}}